module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "#f8f8f8"
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "#f8f8f8"
    }
  }, [_c('el-container', {
    staticStyle: {
      "position": "relative",
      "width": "1240px",
      "height": "100%",
      "margin": "0 auto",
      "overflow": "hidden"
    }
  }, [_c('div', {
    ref: "asideFixedMenu",
    staticClass: "has-vertical-scrollerbar",
    staticStyle: {
      "transition": "all 0.2s",
      "width": "200px",
      "min-width": "200px",
      "padding": "20px 0"
    },
    attrs: {
      "id": "asideFixedMenu"
    }
  }, [_c('el-menu', {
    attrs: {
      "collapse": _vm.isCollapsed,
      "mode": "vertical",
      "default-active": _vm.activeMenuIndex,
      "active-text-color": "##1890FF",
      "default-openeds": ['1', '2', '3'],
      "router": ""
    }
  }, [_c('el-submenu', {
    attrs: {
      "index": "1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-s-custom"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$T('个人中心')))])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/updateinfo"
    }
  }, [_vm._v(_vm._s(_vm.$T('资料修改')))]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/isai-apply-list"
    }
  }, [_vm._v(_vm._s(_vm.$T('我报名的赛事')))])], 2)], 1)], 1), _vm._v(" "), _c('el-main', [_c('keep-alive', {
    attrs: {
      "include": _vm.keepAliveInclude
    }
  }, [_c('router-view', {
    staticClass: "main-content"
  })], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-376e8379","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/mine/MineLayout.vue
// module id = 1368
// module chunks = 0